export const getQuestionsEthnicity = (selectedEthnicity, t) => {
  return [
    {
      checked: selectedEthnicity === '1',
      value: '1',
      label: t('onboarding.generalSection.generalStep3.question1'),
    },
    {
      checked: selectedEthnicity === '2',
      value: '2',
      label: t('onboarding.generalSection.generalStep3.question2'),
    },
    {
      checked: selectedEthnicity === '3',
      value: '3',
      label: t('onboarding.generalSection.generalStep3.question3'),
    },
    {
      checked: selectedEthnicity === '4',
      value: '4',
      label: t('onboarding.generalSection.generalStep3.question4'),
    },
    {
      checked: selectedEthnicity === '5',
      value: '5',
      label: t('onboarding.generalSection.generalStep3.question5'),
    },
  ];
};

export const getWeightMetrics = t => {
  return [
    {
      minValue: 85,
      maxValue: 350,
      validationMsg: t(
        'onboarding.generalSection.generalStep2.minWeightMessageLbs'
      ),
      metricName: 'lbs',
      metricCode: 'lbs',
    },
    {
      minValue: 40,
      maxValue: 160,
      validationMsg: t(
        'onboarding.generalSection.generalStep2.minWeightMessageKg'
      ),
      metricName: 'kg',
      metricCode: 'kg',
    },
  ];
};

export const getHeightMetrics = t => {
  return [
    {
      minValues: [4, 0],
      maxValues: [7, 11],
      validationMsgs: [
        t('onboarding.generalSection.generalStep2.minHeightMessageFt'),
        t('onboarding.generalSection.generalStep2.minHeightMessageIn'),
      ],
      metricName: 'ft',
      metricCode: 'ft',
    },
    {
      minValues: [100],
      maxValues: [250],
      validationMsgs: [
        t('onboarding.generalSection.generalStep2.minHeightMessageCm'),
      ],
      metricName: 'cm',
      metricCode: 'cm',
    },
  ];
};

export const getMedicationsQuestionsSwitch = (selected, t) => {
  return [
    {
      checked: selected === '1',
      value: '1',
      label: t('onboarding.medicationsSection.medicationStep1.yes'),
    },
    {
      checked: selected === '2',
      value: '2',
      label: t('onboarding.medicationsSection.medicationStep1.no'),
    },
  ];
};

export const getAceValuesArr = aceValuesObj => {
  const values = [];
  if (aceValuesObj['benazepril'] === 1) {
    values.push('1');
  }
  if (aceValuesObj['aptopril'] === 1) {
    values.push('2');
  }
  if (aceValuesObj['enalapril'] === 1) {
    values.push('3');
  }
  if (aceValuesObj['fosinopril'] === 1) {
    values.push('4');
  }
  if (aceValuesObj['lisinopril'] === 1) {
    values.push('5');
  }
  if (aceValuesObj['moexipril'] === 1) {
    values.push('6');
  }
  if (aceValuesObj['perindopril'] === 1) {
    values.push('7');
  }
  if (aceValuesObj['quinapril'] === 1) {
    values.push('8');
  }
  if (aceValuesObj['ramipril'] === 1) {
    values.push('9');
  }
  if (aceValuesObj['trandolapril'] === 1) {
    values.push('10');
  }
  return values;
};

export const getArbValuesArr = arbValuesObj => {
  const values = [];
  if (arbValuesObj['azilsartan'] === 1) {
    values.push('1');
  }
  if (arbValuesObj['candesartan'] === 1) {
    values.push('2');
  }
  if (arbValuesObj['eprosartan'] === 1) {
    values.push('3');
  }
  if (arbValuesObj['irbesartan'] === 1) {
    values.push('4');
  }
  if (arbValuesObj['telmisartan'] === 1) {
    values.push('5');
  }
  if (arbValuesObj['valsartan'] === 1) {
    values.push('6');
  }
  if (arbValuesObj['losartan'] === 1) {
    values.push('7');
  }
  if (arbValuesObj['olmesartan'] === 1) {
    values.push('8');
  }
  if (arbValuesObj['entresto'] === 1) {
    values.push('9');
  }
  if (arbValuesObj['byvalson'] === 1) {
    values.push('10');
  }
  return values;
};

export const getAceValuesObj = () => {
  let userAce = {};
  userAce['benazepril'] = 0;
  userAce['aptopril'] = 0;
  userAce['enalapril'] = 0;
  userAce['fosinopril'] = 0;
  userAce['lisinopril'] = 0;
  userAce['moexipril'] = 0;
  userAce['perindopril'] = 0;
  userAce['quinapril'] = 0;
  userAce['ramipril'] = 0;
  userAce['trandolapril'] = 0;

  return userAce;
};

export const getArbValuesObj = () => {
  let userArb = {};
  userArb['azilsartan'] = 0;
  userArb['candesartan'] = 0;
  userArb['eprosartan'] = 0;
  userArb['irbesartan'] = 0;
  userArb['telmisartan'] = 0;
  userArb['valsartan'] = 0;
  userArb['losartan'] = 0;
  userArb['olmesartan'] = 0;
  userArb['entresto'] = 0;
  userArb['byvalson'] = 0;

  return userArb;
};

export const getAceQuestions = (selectedItems, t) => {
  return [
    {
      checked: selectedItems.includes('1'),
      value: '1',
      label: t('onboarding.medicationsSection.medicationStep2.question1'),
    },
    {
      checked: selectedItems.includes('2'),
      value: '2',
      label: t('onboarding.medicationsSection.medicationStep2.question2'),
    },
    {
      checked: selectedItems.includes('3'),
      value: '3',
      label: t('onboarding.medicationsSection.medicationStep2.question3'),
    },
    {
      checked: selectedItems.includes('4'),
      value: '4',
      label: t('onboarding.medicationsSection.medicationStep2.question4'),
    },
    {
      checked: selectedItems.includes('5'),
      value: '5',
      label: t('onboarding.medicationsSection.medicationStep2.question5'),
    },
    {
      checked: selectedItems.includes('6'),
      value: '6',
      label: t('onboarding.medicationsSection.medicationStep2.question6'),
    },
    {
      checked: selectedItems.includes('7'),
      value: '7',
      label: t('onboarding.medicationsSection.medicationStep2.question7'),
    },
    {
      checked: selectedItems.includes('8'),
      value: '8',
      label: t('onboarding.medicationsSection.medicationStep2.question8'),
    },
    {
      checked: selectedItems.includes('9'),
      value: '9',
      label: t('onboarding.medicationsSection.medicationStep2.question9'),
    },
    {
      checked: selectedItems.includes('10'),
      value: '10',
      label: t('onboarding.medicationsSection.medicationStep2.question10'),
    },
    {
      checked: selectedItems.includes('11'),
      value: '11',
      label: t('onboarding.medicationsSection.medicationStep2.question11'),
    },
  ];
};

export const getArbQuestions = (selectedItems, t) => {
  return [
    {
      checked: selectedItems.includes('1'),
      value: '1',
      label: t('onboarding.medicationsSection.medicationStep3.question1'),
    },
    {
      checked: selectedItems.includes('2'),
      value: '2',
      label: t('onboarding.medicationsSection.medicationStep3.question2'),
    },
    {
      checked: selectedItems.includes('3'),
      value: '3',
      label: t('onboarding.medicationsSection.medicationStep3.question3'),
    },
    {
      checked: selectedItems.includes('4'),
      value: '4',
      label: t('onboarding.medicationsSection.medicationStep3.question4'),
    },
    {
      checked: selectedItems.includes('5'),
      value: '5',
      label: t('onboarding.medicationsSection.medicationStep3.question5'),
    },
    {
      checked: selectedItems.includes('6'),
      value: '6',
      label: t('onboarding.medicationsSection.medicationStep3.question6'),
    },
    {
      checked: selectedItems.includes('7'),
      value: '7',
      label: t('onboarding.medicationsSection.medicationStep3.question7'),
    },
    {
      checked: selectedItems.includes('8'),
      value: '8',
      label: t('onboarding.medicationsSection.medicationStep3.question8'),
    },
    {
      checked: selectedItems.includes('9'),
      value: '9',
      label: t('onboarding.medicationsSection.medicationStep3.question9'),
    },
    {
      checked: selectedItems.includes('10'),
      value: '10',
      label: t('onboarding.medicationsSection.medicationStep3.question10'),
    },
    {
      checked: selectedItems.includes('11'),
      value: '11',
      label: t('onboarding.medicationsSection.medicationStep3.question11'),
    },
  ];
};

export const getCovid19TestedQuestions = (selectedTested, t) => {
  return [
    {
      checked: selectedTested === '1',
      value: '1',
      label: t('common.answers.answerYes'),
      id: 'testedYes',
    },
    {
      checked: selectedTested === '2',
      value: '2',
      label: t('common.answers.answerNo'),
      id: 'testedNo',
    },
  ];
};

export const getCovid19AntibodiesTestedQuestions = (selectedTested, t) => {
  return [
    {
      checked: selectedTested === '1',
      value: '1',
      label: t('common.answers.answerYes'),
      id: 'antibodiesTestedYes',
    },
    {
      checked: selectedTested === '2',
      value: '2',
      label: t('common.answers.answerNo'),
      id: 'antibodiesTestedNo',
    },
  ];
};

export const getCovid19Contact = (selectedInContact, t) => {
  return [
    {
      checked: selectedInContact === 1,
      value: '1',
      label: t('common.answers.answerYes'),
    },
    {
      checked: selectedInContact === 0,
      value: '0',
      label: t('common.answers.answerNo'),
    },
  ];
};

export const getComorbiditiesValuesArr = covidComorbiditiesObj => {
  let values = [];
  if (covidComorbiditiesObj['hypertension'] === 1) {
    values.push('1');
  }
  if (covidComorbiditiesObj['diabetes'] === 1) {
    values.push('2');
  }
  if (covidComorbiditiesObj['coronary_artery_disease'] === 1) {
    values.push('3');
  }
  if (covidComorbiditiesObj['heart_failure'] === 1) {
    values.push('4');
  }
  if (covidComorbiditiesObj['asthma'] === 1) {
    values.push('5');
  }
  if (covidComorbiditiesObj['obstructive_pulmonary_disease'] === 1) {
    values.push('6');
  }
  if (covidComorbiditiesObj['sleep_apnea'] === 1) {
    values.push('7');
  }
  if (covidComorbiditiesObj['transplant'] === 1) {
    values.push('8');
  }
  if (covidComorbiditiesObj['kidney_disease'] === 1) {
    values.push('9');
  }
  if (covidComorbiditiesObj['liver_disease'] === 1) {
    values.push('10');
  }
  if (covidComorbiditiesObj['autoimmune_disorder'] === 1) {
    values.push('11');
  }
  if (covidComorbiditiesObj['pneumonia'] === 1) {
    values.push('12');
  }
  if (covidComorbiditiesObj['cancer'] === 1) {
    values.push('13');
  }
  if (covidComorbiditiesObj['hiv'] === 1) {
    values.push('14');
  }
  if (covidComorbiditiesObj['hepatitis_b'] === 1) {
    values.push('15');
  }
  if (covidComorbiditiesObj['hepatitis_c'] === 1) {
    values.push('16');
  }
  if (covidComorbiditiesObj['hyperlipidemia'] === 1) {
    values.push('18');
  }
  return values;
};

export const getComorbiditiesQuestions = (selectedItems, t) => {
  return [
    {
      checked: selectedItems.includes('1'),
      value: '1',
      label: t('onboarding.diseasesSection.diseasesStep4.question1'),
    },
    {
      checked: selectedItems.includes('2'),
      value: '2',
      label: t('onboarding.diseasesSection.diseasesStep4.question2'),
    },
    {
      checked: selectedItems.includes('3'),
      value: '3',
      label: t('onboarding.diseasesSection.diseasesStep4.question3'),
    },
    {
      checked: selectedItems.includes('4'),
      value: '4',
      label: t('onboarding.diseasesSection.diseasesStep4.question4'),
    },
    {
      checked: selectedItems.includes('5'),
      value: '5',
      label: t('onboarding.diseasesSection.diseasesStep4.question5'),
    },
    {
      checked: selectedItems.includes('6'),
      value: '6',
      label: t('onboarding.diseasesSection.diseasesStep4.question6'),
    },
    {
      checked: selectedItems.includes('7'),
      value: '7',
      label: t('onboarding.diseasesSection.diseasesStep4.question7'),
    },
    {
      checked: selectedItems.includes('8'),
      value: '8',
      label: t('onboarding.diseasesSection.diseasesStep4.question8'),
    },
    {
      checked: selectedItems.includes('9'),
      value: '9',
      label: t('onboarding.diseasesSection.diseasesStep4.question9'),
    },
    {
      checked: selectedItems.includes('10'),
      value: '10',
      label: t('onboarding.diseasesSection.diseasesStep4.question10'),
    },
    {
      checked: selectedItems.includes('11'),
      value: '11',
      label: t('onboarding.diseasesSection.diseasesStep4.question11'),
    },
    {
      checked: selectedItems.includes('12'),
      value: '12',
      label: t('onboarding.diseasesSection.diseasesStep4.question12'),
    },
    {
      checked: selectedItems.includes('13'),
      value: '13',
      label: t('onboarding.diseasesSection.diseasesStep4.question13'),
    },
    {
      checked: selectedItems.includes('14'),
      value: '14',
      label: t('onboarding.diseasesSection.diseasesStep4.question14'),
    },
    {
      checked: selectedItems.includes('15'),
      value: '15',
      label: t('onboarding.diseasesSection.diseasesStep4.question15'),
    },
    {
      checked: selectedItems.includes('16'),
      value: '16',
      label: t('onboarding.diseasesSection.diseasesStep4.question16'),
    },
    {
      checked: selectedItems.includes('18'),
      value: '18',
      label: t('onboarding.diseasesSection.diseasesStep4.question18'),
    },
    {
      checked: selectedItems.includes('17'),
      value: '17',
      label: t('onboarding.diseasesSection.diseasesStep4.question17'),
    },
  ];
};

export const getSymptomsQuestions = t => {
  return [
    t('common.answers.answerNotAtAll'),
    t('common.answers.answerMaybeNotSure'),
    t('common.answers.answerYesButMildly'),
    t('common.answers.answerYesModeratly'),
    t('common.answers.answerYesStrongly'),
  ];
};

export const getHealthQuestions = (selectedItems, diseases, t) => {
  return [
    {
      checked: diseases['flu'] && diseases['flu'] !== 0,
      value: '1',
      label: t('onboarding.diseasesSection.diseasesStep6.question1'),
    },
    {
      checked: diseases['lung_infection'] && diseases['lung_infection'] !== 0,
      value: '2',
      label: t('onboarding.diseasesSection.diseasesStep6.question2'),
    },
    {
      checked:
        diseases['strong_allergies'] && diseases['strong_allergies'] !== 0,
      value: '3',
      label: t('onboarding.diseasesSection.diseasesStep6.question3'),
    },
    {
      checked:
        diseases['autoimmune_issues'] && diseases['autoimmune_issues'] !== 0,
      value: '4',
      label: t('onboarding.diseasesSection.diseasesStep6.question4'),
    },
    {
      checked: diseases['out_of_breath'] && diseases['out_of_breath'] !== 0,
      value: '5',
      label: t('onboarding.diseasesSection.diseasesStep6.question5'),
    },
    {
      checked: diseases['depression'] && diseases['depression'] !== 0,
      value: '6',
      label: t('onboarding.diseasesSection.diseasesStep6.question6'),
    },
    {
      checked:
        diseases['memory_loss_confusion'] &&
        diseases['memory_loss_confusion'] !== 0,
      value: '7',
      label: t('onboarding.diseasesSection.diseasesStep6.question7'),
    },
    {
      checked: selectedItems && selectedItems.includes('8'),
      value: '8',
      label: t('onboarding.diseasesSection.diseasesStep6.question8'),
    },
  ];
};

const isValueDisabled = (selectedItems, value) => {
  if (selectedItems.includes('1')) {
    return value !== '1';
  } else if (selectedItems.includes('2') || selectedItems.includes('3')) {
    return value !== '2' && value !== '3';
  } else {
    return false;
  }
};

export const getLivingArrangementsQuestions = (selectedItems, t) => {
  return [
    {
      checked: selectedItems.includes('1'),
      value: '1',
      label: t('onboarding.environmentSection.environmentStep1.question1'),
      disabled: isValueDisabled(selectedItems, '1'),
    },
    {
      checked: selectedItems.includes('2'),
      value: '2',
      label: t('onboarding.environmentSection.environmentStep1.question2'),
      disabled: isValueDisabled(selectedItems, '2'),
    },
    {
      checked: selectedItems.includes('3'),
      value: '3',
      label: t('onboarding.environmentSection.environmentStep1.question3'),
      disabled: isValueDisabled(selectedItems, '3'),
    },
    {
      checked: selectedItems.includes('4'),
      value: '4',
      label: t('onboarding.environmentSection.environmentStep1.question4'),
      disabled: false,
    },
    {
      checked: selectedItems.includes('5'),
      value: '5',
      label: t('onboarding.environmentSection.environmentStep1.question5'),
      disabled: false,
    },
    /*{
      checked: selectedItems.includes('6'),
      value: '6',
      label: t('onboarding.environmentSection.environmentStep1.question6'),
      disabled: isValueDisabled(selectedItems, '6'),
    },*/
  ];
};

export const getWorkStatusQuestions = (selectedWorkStatus, t) => {
  return [
    {
      checked: selectedWorkStatus === '1',
      value: '1',
      label: t(
        'onboarding.environmentSection.environmentStep2.questionWorkEnv1'
      ),
      id: 'employed',
    },
    {
      checked: selectedWorkStatus === '2',
      value: '2',
      label: t(
        'onboarding.environmentSection.environmentStep2.questionWorkEnv2'
      ),
      id: 'unemployed',
    },
  ];
};

export const getWorktimeQuestions = (selectedWorkTime, t) => {
  return [
    {
      checked: selectedWorkTime === '1',
      value: '1',
      label: t(
        'onboarding.environmentSection.environmentStep2.questionWorkEnv3'
      ),
      id: 'fullTimeEmployed',
    },
    {
      checked: selectedWorkTime === '2',
      value: '2',
      label: t(
        'onboarding.environmentSection.environmentStep2.questionWorkEnv4'
      ),
      id: 'partTimeEmployed',
    },
    {
      checked: selectedWorkTime === '3',
      value: '3',
      label: t(
        'onboarding.environmentSection.environmentStep2.questionWorkEnv5'
      ),
      id: 'freelance',
    },
  ];
};

export const getSelectedWorkPeopleQuestions = (selectedWorkEnvironment, t) => {
  return [
    {
      checked: selectedWorkEnvironment === '1',
      value: '1',
      label: t(
        'onboarding.environmentSection.environmentStep2.questionWorkEnv6'
      ),
      id: 'fewPeople',
    },
    {
      checked: selectedWorkEnvironment === '2',
      value: '2',
      label: t(
        'onboarding.environmentSection.environmentStep2.questionWorkEnv7'
      ),
      id: 'manyPeople',
    },
  ];
};
